import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/caosconfiguration/template";

export class DeleteConfigurationTemplateCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";
    params: DeleteConfigurationTemplateReqData = null;

    constructor(templateId: number) {
        super();
        this.params = new DeleteConfigurationTemplateReqData(templateId);
    }

    public async execute(): Promise<ApiGenericResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new ApiGenericResponse(res);
    }
}

export class DeleteConfigurationTemplateReqData {
    id: number;

    constructor(templateId: number) {
        this.id = templateId;
    }
}
